


<app-website-header></app-website-header>

<div class="container-fluid">

    <section class="about">
        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>


        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="about-image">
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 45px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: 0.32px;
                text-align: left;
                color: #ff6d11;">Services</p>
                <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>
        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="col-sm-2" style="margin-left: -14px;">
                <a href="federal"class="services" > <p ><span style="font-weight: bolder;"> > </span> Federal & State Filing   </p></a>
                <a href="itIn"class="services"><p ><span style="font-weight: bolder;"> > </span> ITIN Preparation  </p></a>
                <a href="fbar"class="services"><p> <span style="font-weight: bolder;" > ></span> FBAR & FATCA Compliance  </p></a>
                <a href="tax"class="services"><p> <span style="font-weight: bolder;" > ></span> Tax Representation  </p></a>
                <a href="advanced"class="services"><p> <span style="font-weight: bolder;" > ></span> Advanced Tax Planning  </p></a>
                <a href="amendment"class="services"><p > <span style="font-weight: bolder;" > ></span> Amendment Filing  </p></a>
                <a href="evaluation"class="services"><p style="color: #ff6d11;" > <span style="font-weight: bolder;color: #ff6d11;" > ></span> Tax Evaluation  </p></a>
               <a href="filing"class="services"> <p > <span style="font-weight: bolder;" > ></span> Extension Filing  </p></a>
             </div>


            <div class="col-sm-7" style="margin-left: 105px;">
                <p style="font-family: Raleway;
                font-size: 24px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: 0.24px;
                text-align: left;
                color: #ff6d11;" >Tax Evaluation</p>
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.75;
                letter-spacing: 0.13px;
                text-align: left;
                color: #000000;"> File your individual Income tax return (Form 1040, 1040A, or 1040EZ) and Pay any tax due before April 15th to avoid penalties and Interests.</p>

                   
            </div>
            <div class="col-sm-2"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>

       

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 50px"></div>
        </div>

    
        <div class="row">
            <div class="col-sm-1"></div>

            <div class="col-sm-5">
                <p class="need-help">NEED HELP?</p> <br>
                <p class="need-content">
                        Contact our customer support team if you have any further questions. We are here to help you out.
                </p> <br>

                 <a href="tel:+1(888)690-5754">
                        <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                    height: 50px;
                                    object-fit: contain;
                                    border-radius: 25px;
                                    background-color: #ff6d11;
                                    color: white;">
                        +1 (888) 690 - 5754 &nbsp;
                    </button>
                    </a>
            </div>

            <div class="col-sm-5">
                <img src="assets/section-images/Group 1364.png">
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 65px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>
    </section>

</div>

<app-website-footer></app-website-footer>